import * as React from 'react'

const BillingActivity = (props: { className: string }) => {
  return (
    <svg className={'icon ' + props.className} viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
      <g id='Canvas'>
        <g id='Billing activity' clipPath='url(#clip0)'>
          <path
            d='M 12 0C 5.376 0 0 5.376 0 12C 0 18.624 5.376 24 12 24C 18.624 24 24 18.624 24 12C 24 5.376 18.624 0 12 0ZM 13.692 19.308L 13.692 21.6L 10.488 21.6L 10.488 19.284C 8.436 18.852 6.696 17.532 6.564 15.204L 8.916 15.204C 9.036 16.464 9.9 17.448 12.096 17.448C 14.448 17.448 14.976 16.272 14.976 15.54C 14.976 14.544 14.448 13.608 11.772 12.972C 8.796 12.252 6.756 11.028 6.756 8.568C 6.756 6.504 8.424 5.16 10.488 4.716L 10.488 2.4L 13.692 2.4L 13.692 4.74C 15.924 5.28 17.04 6.972 17.112 8.808L 14.76 8.808C 14.7 7.476 13.992 6.564 12.096 6.564C 10.296 6.564 9.216 7.38 9.216 8.532C 9.216 9.54 9.996 10.2 12.42 10.824C 14.844 11.448 17.436 12.492 17.436 15.516C 17.424 17.712 15.78 18.912 13.692 19.308Z'
            id='Vector'
          />
        </g>
      </g>
      <defs>
        <clipPath id='clip0'>
          <rect width='24' height='24' fill='#fff' />
        </clipPath>
      </defs>
    </svg>
  )
}
export default BillingActivity



// WEBPACK FOOTER //
// ./src/components/icons/main-menu/BillingActivity.tsx